// extracted by mini-css-extract-plugin
export var container = "_7j-0";
export var error = "_7j-9";
export var label = "_7j-5";
export var light = "_7j-6";
export var md = "_7j-3";
export var sm = "_7j-2";
export var thin = "_7j-8";
export var thinBold = "_7j-7";
export var vertical = "_7j-4";
export var xs = "_7j-1";